import{c as n}from"./index-05c3b45e.js";import e from"styled-components";function o(){var e=n(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);return o=function(){return e},e}var r=e.div(o());export{r as E};
